import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-m-urban",
  "use": "icon-m-urban-usage",
  "viewBox": "0 0 40 40",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 40 40\" id=\"icon-m-urban\"><path d=\"M1 32.133V10.6h11.4v15.2M39 32.133V6.8H26.333v19M4.8 15.667h3.8m-3.8 5.066h3.8m21.533-8.866H35.2m-5.067 5.066H35.2M30.133 22H35.2m-22.8 3.8L6.067 37.2m20.266-11.4 7.6 11.4M19.367 27.067v3.8m0 3.8V37.2M12.4 25.8h13.933\" stroke=\"#000\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol